import { Unit, UnitBaseTypes } from "../../Units";

function KilopoundPerSquareInch() {
  return (
    <>
      <Unit unit={UnitBaseTypes.ksi} />
    </>
  );
}

export default KilopoundPerSquareInch;
